import React, { useState, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import { Table, Thead, Tbody, Th, Tr, Td } from "../elements/Table";
import { Heading, Anchor, Icon, Box, Text, Input, Image, Button } from "../elements";

export default function DealsTable({ thead, tbody, dict_class_css }) {
    const [alertModal, setAlertModal] = useState(false);
    const [data, setData] = useState([]);


    useEffect(()=> { setData(tbody) }, [tbody]);

    function truncate( str, n, useWordBoundary ){
        str = str===null?"":str;
        if (str.length <= n) { return str; }
        const subString = str.slice(0, n-1); // the original check
        return (useWordBoundary 
          ? subString.slice(0, subString.lastIndexOf(" ")) 
          : subString) + "...";
      };

    return (
        <Box className="mc-table-responsive">
            <Table className="mc-table">
                <Thead className="mc-table-head primary">
                    <Tr>
                        <Th>
                            <Box className="mc-table-check">
                                <Text>#</Text>
                            </Box>
                        </Th>
                        {thead.map((item, index) => (
                            <Th key={ index }>{ item }</Th>
                        ))}
                    </Tr>
                </Thead>
                <Tbody className="mc-table-body even">
                    {data?.map((item, index) => (
                        <Tr key={ index }> 
                            <Td>
                                <Box className="mc-table-check">
                                    <Text>{item.row_num}</Text>
                                   
                                </Box>
                            </Td>
                            <Td>
                                <Box className="mc-table-profile">
                                <Anchor href={"/customer-view?name=".concat(encodeURIComponent(item.name))} title={item.name}>
                                <p data-letters={item.name_initials}>{item.name}</p>
                                </Anchor>
                                </Box>
                            </Td>
                            <Td><Anchor href="#" title={item.AllAddress}>{item.AllAddress}</Anchor></Td>
                            <Td><Text className={"mc-table-badge " + dict_class_css[item.Class] } >{item.Class}</Text></Td>
                            <Td><Box className="mc-table-profile">
                                    {item.DefaultSalesman}
                                </Box>
                            </Td>
                            <Td>{item.GroupName}</Td>
                            
                            {/*    <Td>
                                <Box className="mc-table-action">
                                    <Anchor title="View" href="/user-profile" className="material-icons view">{ item.action.view }</Anchor>
                                    <Anchor title="Download" href="#" className="material-icons download" download>{ item.action.download }</Anchor>
                                    <Button title="Delete" className="material-icons delete" onClick={()=> setAlertModal(true)}>{ item.action.delete }</Button>
                                </Box>
                            </Td>
                            */}
                        </Tr>
                    ))}
                </Tbody>
            </Table>
            <Modal show={ alertModal } onHide={()=> setAlertModal(false)}>
                <Box className="mc-alert-modal">
                    <Icon type="new_releases" />
                    <Heading as="h3">are your sure!</Heading>
                    <Text as="p">Want to delete this deals?</Text>
                    <Modal.Footer>
                        <Button type="button" className="btn btn-secondary" onClick={()=> setAlertModal(false)}>nop, close</Button>
                        <Button type="button" className="btn btn-danger" onClick={()=> setAlertModal(false)}>yes, delete</Button>
                    </Modal.Footer>
                </Box>
            </Modal>
        </Box>
    )
}